import { createBrowserRouter } from "react-router-dom";
import routes from "./components/pages";

const Router = () => {
  return createBrowserRouter([...routes]);
};

export default Router;
